// Contenu éditorial du site VF Création Vidéo Immersive

export const CONTACT = {
  phone: "06 89 10 49 78",
  phoneHref: "tel:+33689104978",
  email: "valerieboccara@hotmail.fr",
  whatsapp: "https://wa.me/33689104978",
  whatsappNumber: "06 89 10 49 78",
  instagram: "https://instagram.com/vfpublicite",
};

export const HERO = {
  eyebrow: "Vidéos publicitaires immersives — France & International",
  titleTop: "L'émotion est le meilleur",
  titleBottom: "outil de communication.",
  subtitle:
    "VF Création Vidéo Immersive conçoit des vidéos publicitaires immersives premium, grâce aux dernières technologies visuelles, pour capter l'attention, renforcer votre image de marque et créer une expérience client mémorable.",
};

// Showreel de démonstration temporaire — remplacé par votre propre vidéo dès son upload.
// Séquence d'industries pour faire comprendre instantanément votre activité.
export const SHOWREEL_SLIDES = [
  { label: "Immobilier", img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  { label: "Commerces de proximité", img: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  { label: "Boutiques de luxe", img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  { label: "Hôtels & restaurants", img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  { label: "Entreprises & marques", img: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  { label: "Concessions automobiles", img: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
];

export const SERVICES = [
  {
    n: "01",
    title: "Vidéos publicitaires immersives",
    text: "Des films premium qui plongent le spectateur au cœur de votre univers et transforment le regard en émotion.",
  },
  {
    n: "02",
    title: "Technologies visuelles de pointe",
    text: "Les dernières innovations créatives pour un rendu spectaculaire, moderne et résolument différenciant.",
  },
  {
    n: "03",
    title: "Communication émotionnelle",
    text: "Raconter votre marque à travers l'émotion pour marquer durablement les esprits et créer le désir.",
  },
  {
    n: "04",
    title: "Image de marque premium",
    text: "Renforcer votre positionnement et offrir à vos clients une expérience mémorable, quelle que soit votre taille.",
  },
];

export const PRESTATIONS = [
  "Vidéos publicitaires immersives",
  "Films de marque émotionnels",
  "Formats verticaux (Reels, TikTok, Stories)",
  "Étalonnage cinéma & sound design",
  "Contenus produits & e-commerce",
  "Habillage & motion design",
  "Expériences immersives sur-mesure",
  "Direction artistique premium",
];

// Catégories du portfolio (galerie filtrable) — reflètent tous types d'entreprises
export const CATEGORIES = [
  "Immobilier",
  "Commerces de proximité",
  "Boutiques de luxe",
  "Hôtels & restaurants",
  "Communication d'entreprise",
  "Mobilité & Deux-roues",
  "Concessions automobiles",
  "Communication de marque",
  "Chirurgie esthétique",
  "Médecine esthétique",
  "Autres projets",
  "Rejoignez notre équipe",
  "Créations futuristes",
  "🎞️ Films d'époque",
];

export const PORTFOLIO_CATEGORIES = ["Tous", ...CATEGORIES];

// Placeholders de démonstration, clairement identifiés (badge « Démo »).
export const DEMO_PORTFOLIO = [
  { id: "d1", title: "Résidence d'exception", category: "Immobilier", img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d2", title: "Villa panoramique", category: "Immobilier", img: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d3", title: "Commerce de quartier", category: "Commerces de proximité", img: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d4", title: "Maison couture", category: "Boutiques de luxe", img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d5", title: "Concession premium", category: "Concessions automobiles", img: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d9", title: "Mobilité urbaine", category: "Mobilité & Deux-roues", img: "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d6", title: "Hôtel & table", category: "Hôtels & restaurants", img: "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d7", title: "Campagne de marque", category: "Communication de marque", img: "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "d8", title: "Présentation d'entreprise", category: "Communication d'entreprise", img: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export const METHOD = [
  { n: "01", title: "Analyse du projet", text: "Nous étudions votre univers, vos objectifs et l'émotion à transmettre afin de définir une direction créative claire et sur-mesure." },
  { n: "02", title: "Création de la vidéo", text: "Nous imaginons un concept immersif : narration, ambiance, lumière et rythme cinématographique au service de votre marque." },
  { n: "03", title: "Production immersive", text: "Nous réalisons votre vidéo avec les dernières technologies visuelles, pour un rendu premium, spectaculaire et unique." },
  { n: "04", title: "Montage et finalisation", text: "Montage, étalonnage cinéma, sound design et livraison optimisée pour tous vos supports, prête à captiver votre audience." },
];

export const FAQ = [
  { q: "Quel type de vidéos réalisez-vous ?", a: "Des vidéos publicitaires immersives premium, conçues avec les dernières technologies visuelles pour créer de l'émotion et sublimer votre image de marque." },
  { q: "Combien coûte une vidéo ?", a: "Chaque devis est personnalisé selon l'ampleur et l'ambition de votre projet. Contactez-moi pour une proposition sur-mesure." },
  { q: "Quels sont les délais de livraison ?", a: "En moyenne 3 à 5 jours ouvrés après la création, selon la complexité du montage et de la post-production." },
  { q: "Dans quels secteurs intervenez-vous ?", a: "Immobilier, commerces de proximité, boutiques de luxe, concessions automobiles, hôtels & restaurants, entreprises et communication de marque." },
  { q: "Intervenez-vous partout ?", a: "Oui, nous nous déplaçons partout en France et à l'international pour donner vie à vos projets." },
];
